import compliance from "./compliance.json";
import hardware from "./hardware.json";
import infrastructure from './infrastructure.json';
import security from './security.json';
import software from './software.json';
import training from './training.json';

export default [
    compliance,
    hardware,
    infrastructure,
    security,
    software,
    training
];